// ============ NOVA POSHTA DELIVERY ============
(function() {
  const NP_API_KEY = 'c06abbfd99c3d5cca20b0bf384af8b8e';
  const NP_API = 'https://api.novaposhta.ua/v2.0/json/';

  let selectedMethod = null;
  let selectedCityRef = null;
  let selectedCityName = '';
  let selectedBranchName = '';
let citySearchTimeout = null;
let branchSearchTimeout = null;
let branchCache = {};

  function initNP() {
    const block = document.getElementById('np-delivery-block');
    if (!block) return;
    const saved = JSON.parse(localStorage.getItem('np_delivery') || '{}');
    if (saved.method) restoreState(saved);
    block.querySelectorAll('.np-method-btn').forEach(btn => {
      btn.addEventListener('click', () => selectMethod(btn.dataset.method));
    });
    document.getElementById('np-city-input')?.addEventListener('input', function() {
      clearTimeout(citySearchTimeout);
      citySearchTimeout = setTimeout(() => searchCity(this.value), 400);
    });
document.getElementById('np-branch-input')?.addEventListener('input', function() {
  if (!selectedCityRef) return;
  clearTimeout(branchSearchTimeout);
  const val = this.value.trim();
  branchSearchTimeout = setTimeout(() => {
    let query = val;
    if (/^\d+$/.test(query)) query = '№' + query;
    searchBranch(query, selectedMethod === 'parcel' ? 'parcel' : 'warehouse');
  }, 350);
});
    ['np-street-input', 'np-house-input'].forEach(id => {
      document.getElementById(id)?.addEventListener('input', updateAddressSummary);
    });
      document.querySelectorAll('.np-popular-city').forEach(btn => {
      btn.addEventListener('click', () => {
        const cityName = btn.dataset.city;
        document.getElementById('np-city-input').value = cityName;
        searchCity(cityName);
      });
    });
  }

  function selectMethod(method) {
    selectedMethod = method;
    selectedCityRef = null;
    selectedCityName = '';
    selectedBranchName = '';

    document.querySelectorAll('.np-method-btn').forEach(b => b.classList.remove('active'));
    document.querySelector(`[data-method="${method}"]`)?.classList.add('active');

    const form = document.getElementById('np-form');
    const cityWrap = document.getElementById('np-city-wrap');
    const branchWrap = document.getElementById('np-branch-wrap');
    const addressWrap = document.getElementById('np-address-wrap');
    const pickupInfo = document.getElementById('np-pickup-info');
    const summaryLine = document.getElementById('np-summary-line');

    summaryLine.style.display = 'none';
    pickupInfo.style.display = 'none';
    form.style.display = 'none';
    cityWrap.style.display = 'none';
    branchWrap.style.display = 'none';
    addressWrap.style.display = 'none';
    document.getElementById('np-city-input').value = '';
    document.getElementById('np-branch-input').value = '';
    document.getElementById('np-selected-branch').textContent = '';
    document.getElementById('np-city-list').style.display = 'none';
    document.getElementById('np-branch-list').style.display = 'none';

if (method === 'pickup') {
  pickupInfo.style.display = 'block';
  const delivery = 'Самовивіз';
  summaryLine.textContent = '✓ Самовивіз — оберіть адресу на наступному етапі';
  summaryLine.style.display = 'block';
  saveAndUpdate({ method, delivery });
  enableCheckout();
    } else if (method === 'address') {
      form.style.display = 'block';
      cityWrap.style.display = 'block';
    } else {
      form.style.display = 'block';
      cityWrap.style.display = 'block';
    }

    if (method !== 'pickup') disableCheckout();
  }

  async function searchCity(query) {
    if (query.length < 2) {
      document.getElementById('np-city-list').style.display = 'none';
      return;
    }
    const res = await npRequest({
      modelName: 'Address',
      calledMethod: 'searchSettlements',
      methodProperties: { CityName: query, Limit: 7 }
    });
    const items = res?.data?.[0]?.Addresses || [];
    showList('np-city-list', items, item => `${item.Present}`, item => {
selectedCityRef = item.DeliveryCity;
selectedCityName = item.Present;
document.getElementById('np-city-input').value = item.Present;
document.getElementById('np-city-list').style.display = 'none';
const currentSaved = JSON.parse(localStorage.getItem('np_delivery') || '{}');
saveAndUpdate({ ...currentSaved, cityRef: selectedCityRef, cityName: selectedCityName });
      if (selectedMethod === 'address') {
        document.getElementById('np-address-wrap').style.display = 'block';
        updateAddressSummary();
      } else {
        document.getElementById('np-branch-wrap').style.display = 'block';
      searchBranch('', selectedMethod === 'parcel' ? 'parcel' : 'warehouse');
      }
    });
  }

async function searchBranch(query, method) {
  const cacheKey = selectedCityRef + '_' + method + '_' + query;
  
  let items;
  if (branchCache[cacheKey]) {
    items = branchCache[cacheKey];
  } else {
    const res = await npRequest({
      modelName: 'Address',
      calledMethod: 'getWarehouses',
      methodProperties: {
        CityRef: selectedCityRef,
        FindByString: query,
        Limit: query ? 50 : 500
      }
    });
    items = (res?.data || []).filter(item =>
      method === 'parcel'
        ? item.CategoryOfWarehouse === 'Postomat'
        : item.CategoryOfWarehouse === 'Branch'
    );
    branchCache[cacheKey] = items;
  }

  showList('np-branch-list', items, item => item.Description, item => {
    selectedBranchName = item.Description;
    const postalCode = item.PostalCodeUA || '';
    document.getElementById('np-branch-input').value = '';
    document.getElementById('np-selected-branch').textContent = '✓ ' + item.Description;
    document.getElementById('np-branch-list').style.display = 'none';
    const label = method === 'parcel' ? 'Поштомат' : 'Відділення';
    const summary = `${label}: ${selectedCityName}, ${item.Description}`;
    document.getElementById('np-summary-line').textContent = '✓ ' + summary;
    document.getElementById('np-summary-line').style.display = 'block';
    saveAndUpdate({ method, delivery: summary, postalCode });
    enableCheckout();
  });
}

  function updateAddressSummary() {
    const city = selectedCityName;
    const street = document.getElementById('np-street-input')?.value || '';
    const house = document.getElementById('np-house-input')?.value || '';
    if (city && street && house) {
      const summary = `Адресна: ${city}, ${street}, ${house}`;
      document.getElementById('np-summary-line').textContent = '✓ ' + summary;
      document.getElementById('np-summary-line').style.display = 'block';
      saveAndUpdate({ method: 'address', delivery: summary });
      enableCheckout();
    } else {
      disableCheckout();
    }
  }

  function showList(listId, items, labelFn, onSelect) {
    const ul = document.getElementById(listId);
    ul.innerHTML = '';
    if (!items.length) { ul.style.display = 'none'; return; }
    items.forEach(item => {
      const li = document.createElement('li');
      li.textContent = labelFn(item);
      li.addEventListener('click', () => onSelect(item));
      ul.appendChild(li);
    });
    ul.style.display = 'block';
  }

  async function npRequest(body) {
    try {
      const res = await fetch(NP_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...body, apiKey: NP_API_KEY })
      });
      return await res.json();
    } catch(e) { return null; }
  }

  function saveAndUpdate(data) {
    localStorage.setItem('np_delivery', JSON.stringify(data));
  }

function npProceedToCheckout() {
  const checkbox = document.getElementById('no-call-checkbox');
  const noCall = checkbox?.checked ? 'Так' : 'Ні';
  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ attributes: { 'Не передзвонювати': noCall } })
  }).then(() => {
    const saved = JSON.parse(localStorage.getItem('np_delivery') || '{}');
    if (!saved.delivery) return;
    const delivery = saved.delivery;
    const zip = saved.postalCode || '';
    let address1 = delivery;
    let city = '';
    const parts = delivery.split(': ');
    if (parts.length > 1) {
      const locationParts = parts[1].split(', ');
      city = locationParts[0] || '';
      address1 = locationParts.slice(1).join(', ') || parts[1];
    }

    let params;
    if (saved.method === 'pickup') {
      params = new URLSearchParams({
        'checkout[shipping_address][address1]': 'вул. Паньківська, 18',
        'checkout[shipping_address][city]': 'Київ',
        'checkout[shipping_address][zip]': '01033',
        'checkout[shipping_address][country]': 'Ukraine',
        'checkout[billing_address][address1]': 'вул. Паньківська, 18',
        'checkout[billing_address][city]': 'Київ',
        'checkout[billing_address][zip]': '01033',
        'checkout[billing_address][country]': 'Ukraine',
        'checkout[attributes][Спосіб доставки]': delivery
      });
    } else {
      params = new URLSearchParams({
        'checkout[shipping_address][address1]': address1,
        'checkout[shipping_address][city]': city,
        'checkout[shipping_address][zip]': zip,
        'checkout[shipping_address][country]': 'Ukraine',
        'checkout[attributes][Спосіб доставки]': delivery
      });
    }

    window.location.href = `/checkout?${params.toString()}`;
  });
}

  window.npProceedToCheckout = npProceedToCheckout;

  function enableCheckout() {
    const btn = document.getElementById('checkout');
    if (btn) btn.disabled = false;
  }

  function disableCheckout() {
    const btn = document.getElementById('checkout');
    if (btn) btn.disabled = true;
  }
function restoreState(saved) {
  if (saved.method) selectMethod(saved.method);
  if (saved.cityRef) {
    selectedCityRef = saved.cityRef;
    selectedCityName = saved.cityName || '';
  }
}

  document.addEventListener('DOMContentLoaded', initNP);
  document.addEventListener('cart-drawer:open', initNP);

  const observer = new MutationObserver(() => {
    if (document.getElementById('np-delivery-block')) {
      initNP();
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

})();
